export default {"src":"/_next/static/media/mondial-logo-mark-full-color-rgb.9a4abebc.svg","height":412,"width":564,"blurWidth":0,"blurHeight":0};